// @context TGW-2581 イベント詳細MVスライダーの並び・タップ遷移の計算。main_slider.jsx から
//   React に依存しない部分を切り出し、単体テスト（main_slider.test.js）で固定する。

// スライドの並びは メイン画像 → YouTube → サブ写真 → サークル動画（アプリの event_public_movies と同じく写真の末尾）
export const totalSlidesCount = ({ videoIds = [], subPhotoUrls = [], circleMovieUrls = [] }) =>
  1 + videoIds.length + subPhotoUrls.length + circleMovieUrls.length;

// スライド本体のタップで次へ。最後のスライドでは先頭へ戻る
export const nextIndexOnTap = (index, total) => (total <= 0 ? 0 : (index + 1) % total);

// react-swipeable-views はマウスでのスワイプ終了時にも click が発火するため、
// 押した位置から動いた距離が小さいものだけをタップとみなす
export const TAP_MOVE_THRESHOLD_PX = 10;
export const isTap = (startX, endX) =>
  startX == null || endX == null || Math.abs(endX - startX) < TAP_MOVE_THRESHOLD_PX;
